export const density = {
  standard: {
    dataGrid: { rowHeight: 52, headerHeight: 45 },
    inputSize: 'medium',
    buttonSize: 'medium',
  },
  compact: {
    dataGrid: { rowHeight: 36, headerHeight: 45 },
    inputSize: 'small',
    buttonSize: 'small',
  },
} as const;

export type DensityMode = keyof typeof density;
